import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackPhonesOpen } from './tracking';
import { selectTrackingProducts } from '../../slices';
import { getFormattedPhoneNumber, hideLastDigits } from '../../utils/phones';
import { Phone } from 'shared/components/Phone';

type TProps = {
  phone: string;
};

export const PhoneContainer: React.FC<TProps> = ({ phone }) => {
  const [phonesMinimized, setPhonesMinimized] = React.useState<boolean>(true);

  const products = useSelector(selectTrackingProducts);

  const formattedPhone = React.useMemo(() => {
    return phone ? getFormattedPhoneNumber(phone) : '';
  }, [phone]);

  const hiddenPhone = React.useMemo(() => (formattedPhone ? hideLastDigits(formattedPhone) : ''), [formattedPhone]);

  const handlePhoneClick = React.useCallback(() => {
    trackPhonesOpen(products);
    setPhonesMinimized(false);
  }, [products]);

  return (
    <Phone
      formattedPhone={formattedPhone}
      hiddenPhone={hiddenPhone}
      isPhoneMinimized={phonesMinimized}
      onPhoneClick={handlePhoneClick}
    />
  );
};
